import React, { useEffect, useState, useContext } from 'react';

import useServiceContextProvider from '../../capabilities/contextStore/ServiceContext/useServiceContextProvider';
import { getPreferredLanguage } from '../../utils/session/selectors';
import { AppContext } from '../../capabilities/contextStore/AppContext';
import Dropdown from '../../ui/Dropdown/Dropdown';

import {
  updateUrlWithLanguage,
  getLanguageFromUrl,
} from './utils/handleLanguageInURL';

const LanguageDropdown = () => {
  const {
    originalCheckoutSessionResponse,
    isLanguageDropdownDisabled,
  } = useContext(AppContext);

  const { sessionStorageService: sessionStorageWrapper } =
    useServiceContextProvider();
  const [language, setLanguage] = useState<string>('en');

  const onLanguageChange = (value: string) => {
    setLanguage(value);
    sessionStorageWrapper.setItem(
      'reloadBecauseOfLanguageChange',
      'true',
    );

    // Update the URL with the new language and reload the page
    updateUrlWithLanguage(value);
  };

  useEffect(() => {
    const langInUrl = getLanguageFromUrl();
    const langInSession = getPreferredLanguage(
      originalCheckoutSessionResponse,
    );
    setLanguage(langInUrl || langInSession || 'en');

    sessionStorageWrapper.removeItem(
      'reloadBecauseOfLanguageChange',
    );
  }, []);

  return (
    <Dropdown
      id="languageDropdownSelector"
      value={language}
      onChange={onLanguageChange}
      testid="options"
      disabled={isLanguageDropdownDisabled}
      options={[
        { value: 'en', label: 'English' },
        { value: 'es', label: 'Español (Spanish)' },
      ]}
      inputLabel="Language preference"
    />
  );
};

export default LanguageDropdown;
